// -------------------------------------------------------------------------------------------------------
export function getPrefix(prop: string = 'transform'): string {
    // Checking specifically for 'window.document' is for pseudo-browser server-side
    // environments that define 'window' as the global context.
    // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
    if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';

    const style = window.document.documentElement.style;
    if (prop in style) return '';

    const browserPrefixes = ['Moz', 'Webkit', 'O', 'ms'];
    for (let i = 0; i < browserPrefixes.length; i++) {
        if (browserPrefixToKey(prop, browserPrefixes[i]) in style) return browserPrefixes[i];
    }

    return '';
}
// -------------------------------------------------------------------------------------------------------
export function browserPrefixToKey(prop: string, prefix: string): string {
    return prefix ? `${prefix}${kebabToTitleCase(prop)}` : prop;
}
// -------------------------------------------------------------------------------------------------------
export function browserPrefixToStyle(prop: string, prefix: string): string {
    return prefix ? `-${prefix.toLowerCase()}-${prop}` : prop;
}
// -------------------------------------------------------------------------------------------------------
export function kebabToTitleCase(str: string): string {
    let out = '';
    let shouldCapitalize = true;
    for (let i = 0; i < str.length; i++) {
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') {
            shouldCapitalize = true;
        } else {
            out += str[i];
        }
    }
    return out;
}
    // -------------------------------------------------------------------------------------------------------
